module.exports = __webpack_public_path__ + "img/Patient-Lending-Logo.2d010c2f.svg";